import React from 'react';
import { Trans } from 'react-i18next';
import { useMutation } from "@apollo/client";

import { UPDATE_BOOKING } from '../../../GraphQL/Mutations/bookings';
import { constants } from '../../../Helpers/Constants';

export const RejectApproveBookingButtons = ({ booking, legacyAPIApproveBooking, openRejectBookingModal }) => {
    // const [updateBookingMutation, { data, loading, error }] = useMutation(UPDATE_BOOKING);

    // [not in use due to queue data sync implementation]
    const updateBookingGraphQL = ({ status }) => {
        // const bookingInput = {
        //     id: parseInt(booking.id || booking.extendedProps.booking.id),
        //     status,
        // }

        // updateBookingMutation({ variables: { input: bookingInput } }).then((response) => {
        //     const { calendarRef, event, ...gqlBooking } = booking;

        //     const currentBooking = {
        //         ...gqlBooking,
        //         status,
        //         Book_Status: constants.booking_status[status],
        //         extendedProps: {
        //             ...gqlBooking.extendedProps,
        //             booking: {
        //                 ...gqlBooking.extendedProps.booking,
        //                 status,
        //                 Book_Status: constants.booking_status[status],
        //             },
        //         }
        //     }

        //     localStorage.setItem('currentBooking', JSON.stringify(currentBooking));

        //     window.location.reload();
        // }).catch((error) => {
        //     console.error('[updateBookingMutation] error: ', error);
        // });
    }

    const approveBooking = () => legacyAPIApproveBooking(updateBookingGraphQL);
    const rejectBooking = () => openRejectBookingModal();

    return (
        <div style={{justifyContent: 'flex-start'}}>
            <a className = "button discard ml-16" onClick={rejectBooking}><Trans>Reject</Trans></a>
            <a className = "button approve ml-16" onClick={approveBooking}><Trans>Approve</Trans></a>
        </div>
    )
}